/** Layers that pop up and take the keyboard while they show: a popover's dialog, a menu, or a select's list of options. */
const POPUP_LAYER_SELECTOR = [
  '.chakra-popover__popper [role="dialog"]',
  '.chakra-popover__popper [role="alertdialog"]',
  ".chakra-menu__menu-list",
  '.chakra-popover__popper [role="listbox"]',
  '.chakra-portal [role="menu"]',
  '.chakra-portal [role="listbox"]',
].join(", ");

/**
 * An open popover, a menu, or a list of options is up. A closed layer can stay mounted, hidden, and a list drawn in the
 * page, not popped up, doesn't count, nor does a layer holding an element that `ignore` matches.
 */
export const isPopupLayerOpen = (ignore?: string) =>
  Array.from(document.querySelectorAll(POPUP_LAYER_SELECTOR)).some(
    (layer) =>
      !(ignore && layer.querySelector(ignore)) &&
      layer.getClientRects().length > 0 &&
      getComputedStyle(layer).visibility !== "hidden",
  );
